import { render, staticRenderFns } from "./tipofday.vue?vue&type=template&id=0dab7c62&scoped=true&"
import script from "./tipofday.vue?vue&type=script&lang=js&"
export * from "./tipofday.vue?vue&type=script&lang=js&"
import style0 from "./tipofday.vue?vue&type=style&index=0&id=0dab7c62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab7c62",
  null
  
)

export default component.exports